import React from 'react';
import PropTypes from 'prop-types';

export const INNOGAMES_LINK = 'https://www.innogames.com';

function InnoGamesLink({ linkId = 'n/a' }) {
	return (
		<a
			href={INNOGAMES_LINK}
			target="_blank"
			rel="noreferrer"
			id={linkId}
		>
			InnoGames GmbH
		</a>
	);
}

export default InnoGamesLink;

InnoGamesLink.propTypes = {
	linkId: PropTypes.string,
};